import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { ESTATUS_MAQUINA_VIRTUAL } from '@siptel-web/common';
import React, { useEffect } from 'react';
import LoadingSpinner from 'src/components/LoadingSpinner';
import StyledTableCell from 'src/components/table/StyledTableCell';
import StyledTableRow from 'src/components/table/StyledTableRow';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import { RetryMessage } from '../../RetryMessage';

const boldText = { fontWeight: 700 };

const getEstadoMaquinaVirtual = (str) => {
  let estado = 'Activo';
  let color = 'success';

  if (str === ESTATUS_MAQUINA_VIRTUAL.APAGADA) {
    estado = 'Inactivo';
    color = 'error';
  }

  if (str === ESTATUS_MAQUINA_VIRTUAL.SUSPENDIDA) {
    estado = 'Suspendido';
    color = 'warning';
  }

  return <Chip label={estado} color={color} />;
};

function VerInformacionMaquinaVirtualModal(props) {
  const { open, close } = props;

  const { fetch, loading, data, error } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const getInformacion = React.useCallback(() => {
    fetch(`/maquinas-virtuales/${props?.data?.id}`);
  }, [fetch, props?.data?.id]);

  useEffect(() => {
    getInformacion();
  }, [getInformacion]);

  return (
    <Modal
      title={`Máquina Virtual: ${props?.data?.id}`}
      maxWidth="md"
      content={
        <>
          {loading && <LoadingSpinner />}
          {!loading && error && (
            <RetryMessage
              message="Ocurrió un error al intentar cargar la información."
              retry={getInformacion}
            />
          )}
          {!loading && !error && data && (
            <Table>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>ID</StyledTableCell>
                  <StyledTableCell>{data.id}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>
                    Nombre Máquina
                  </StyledTableCell>
                  <StyledTableCell>{data.nombre}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>RAM</StyledTableCell>
                  <StyledTableCell>{data.ram / 1024} GB</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>CPU</StyledTableCell>
                  <StyledTableCell>{data.cpus}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Guest OS</StyledTableCell>
                  <StyledTableCell>{data.so_invitado}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Estado</StyledTableCell>
                  <StyledTableCell>
                    {getEstadoMaquinaVirtual(data.estado)}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>Disk</StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" spacing={1}>
                      {(data?.discos ?? []).map((disk, index) => (
                        <Chip
                          key={`disk-${index}`}
                          size="small"
                          label={`${disk.etiqueta} - ${
                            disk.capacidad / 1024 ** 3
                          } GB`}
                          color="info"
                        />
                      ))}
                    </Stack>
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell sx={boldText}>NICs</StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="column" spacing={1}>
                      {(data?.nics ?? []).map((nic, index) => (
                        <Chip
                          key={`nic-${index}`}
                          size="small"
                          label={`${nic.etiqueta} - ${nic.direccion_mac} - ${nic.estado} - ${nic.tipo}`}
                          color="info"
                        />
                      ))}
                    </Stack>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          )}
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={false}
      cancelButtonText="Cerrar"
    />
  );
}

export default VerInformacionMaquinaVirtualModal;
